/**
 * Black Horse a11y (audit 5.3.8): announces quantity changes to screen readers.
 *
 * The plus and minus buttons of a quantity selector change the number in the
 * input, but screen readers do not announce a changed input value. This writes
 * "Määrä 2" into the page-level status region #a11y-status, which
 * layout/theme.liquid renders outside every morphed section, so the message
 * survives the cart re-render. The listener is delegated from document
 * (see CLAUDE.md, "Horizon Morph System Gotchas").
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('.quantity-plus, .quantity-minus') : null;
    // No disabled check: the theme's handler runs first and may already have disabled
    // the button it just used (minus at the minimum), and a click on a button that was
    // disabled beforehand never reaches this listener.
    if (!button) return;

    var status = document.getElementById('a11y-status');
    var input = button.parentElement ? button.parentElement.querySelector('input[type="number"]') : null;
    if (!status || !(input instanceof HTMLInputElement)) return;

    // The theme's own click handler (capture phase) has already updated the value.
    var message = (status.dataset.quantityLabel || 'Määrä') + ' ' + input.value;

    // Clear first so that the same message twice in a row is announced again.
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 100);
  });
})();

/**
 * Black Horse a11y (WCAG 2.4.11): keep a focused element from scrolling under the sticky header.
 * utilities.js writes the header height to <body> as --header-height; scroll-padding has to sit on
 * <html>, the scroll container, so mirror the value there and let custom-styles.css use it.
 */
(function () {
  'use strict';

  function sync() {
    var value = document.body ? document.body.style.getPropertyValue('--header-height') : '';
    if (value) document.documentElement.style.setProperty('--bh-header-offset', value);
  }

  sync();
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
  if (window.MutationObserver && document.body) {
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['style'] });
  }
})();

/**
 * Black Horse a11y (WCAG 2.1.1): swipe for product card galleries on touch screens.
 * custom-styles.css stops the gallery from scrolling natively (a scroll region that keyboard
 * users cannot reach), so a horizontal swipe calls the slideshow's own next/previous instead.
 * A swipe must not open the product: the gallery sits inside the card link.
 */
(function () {
  'use strict';

  var start = null;
  var swiped = false;

  document.addEventListener('touchstart', function (event) {
    var slides = event.target instanceof Element ? event.target.closest('product-card slideshow-slides') : null;
    if (!slides || event.touches.length !== 1) { start = null; return; }
    start = { x: event.touches[0].clientX, y: event.touches[0].clientY, slideshow: slides.closest('slideshow-component') };
    swiped = false;
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    if (!start || !start.slideshow) return;
    var touch = event.changedTouches[0];
    var dx = touch.clientX - start.x;
    var dy = touch.clientY - start.y;
    var slideshow = start.slideshow;
    start = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    swiped = true;
    if (dx < 0 && typeof slideshow.next === 'function') slideshow.next();
    if (dx > 0 && typeof slideshow.previous === 'function') slideshow.previous();
  }, { passive: true });

  // The click that follows a swipe would follow the card link.
  document.addEventListener('click', function (event) {
    if (!swiped) return;
    swiped = false;
    if (event.target instanceof Element && event.target.closest('product-card slideshow-slides')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
})();

